export function convertToCamelCase (input) {
  if (input) {
    let part1 = input.substring(0, 1).toUpperCase();
    let part2 = input.substring(1).toLowerCase();
    return part1 + part2;
  }
  return '';
}
